import React from "react";
import { Box, type BoxProps } from "@chakra-ui/react";
import { VideoJsonLd } from "next-seo";

type HeroVideoProps = {
  sourceMp4: string;
  sourceWebm?: string;
  title: string;
  description: string;
  poster: string;
  uploadDate: string;
  isTransparent?: boolean;
};

export function HeroVideo({
  sourceMp4,
  sourceWebm,
  title,
  description,
  poster,
  uploadDate,
  isTransparent,
  ...props
}: HeroVideoProps & BoxProps) {
  return (
    <>
      <Box pos="relative" borderRadius="md" overflow="hidden" maxW={{ base: "2xl", xl: "100%" }} mx="auto" {...props}>
        <video playsInline muted loop autoPlay width="100%" preload="metadata">
          <source src={sourceMp4} type={`video/mp4${isTransparent ? ";codecs=hvc1" : ""}`} />
          {sourceWebm && <source src={sourceWebm} type="video/webm" />}
        </video>
      </Box>

      <VideoJsonLd
        name={title}
        description={description}
        contentUrl={sourceMp4}
        embedUrl={sourceMp4}
        thumbnailUrls={[poster]}
        uploadDate={uploadDate ?? "2023-08-01T08:00:00+08:00"}
      />
    </>
  );
}
